import React from 'react';
import type { ContractStatus } from '../../types';
import './ContractStatusBadge.css';

export type ContractStatusBadgeVariant = ContractStatus;

export interface ContractStatusBadgeProps {
  /** Contract status determining color and label */
  status: ContractStatusBadgeVariant;
  /** Optional suffix appended after the label (e.g. "98%") */
  suffix?: string;
  /** Optional custom className */
  className?: string;
}

const STATUS_CONFIG: Record<ContractStatus, { label: string; modifier: string }> = {
  draft: { label: 'Entwurf', modifier: 'draft' },
  active: { label: 'Aktiv', modifier: 'active' },
  partially_fulfilled: { label: 'Teilerfüllt', modifier: 'partial' },
  fulfilled: { label: 'Erfüllt', modifier: 'fulfilled' },
  over_delivered: { label: 'Überliefert', modifier: 'over' },
  closed: { label: 'Abgeschlossen', modifier: 'closed' },
  expired: { label: 'Abgelaufen', modifier: 'expired' },
};

export const ContractStatusBadge: React.FC<ContractStatusBadgeProps> = ({
  status,
  suffix,
  className = '',
}) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.active;

  return (
    <span
      className={`contract-status-badge contract-status-badge--${config.modifier} ${className}`.trim()}
    >
      {suffix ? `${config.label} ${suffix}` : config.label}
    </span>
  );
};

export default ContractStatusBadge;
